import { UtilsService } from '../utils';
import { authorizedAPI } from '@/config/axios.config';
import { delegationSession } from '@/lib/delegation-session';
import { delegationService } from '../delegation/delegation.service';

export interface AddToDatabaseParams {
    name?: string;
    status?: string;
    parentId?: string | null;
    levelNames?: Array<{ levelId: string; levelName: string }>;
}

const utils = new UtilsService();

class AddToDatabaseService {
    createAddToDatabase(data: AddToDatabaseParams): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.post('/add-to-database', data));
    }

    getAllAddToDatabases(): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get('/add-to-database'));
    }

    getAddToDatabaseById(id: string): Promise<any> {
        // Same list, reached through the delegation link when there is no session.
        if (delegationSession.isActive) {
            return delegationService.getDatabase(id);
        }

        return utils.handleApiRequest(() => authorizedAPI.get(`/add-to-database/${id}`));
    }

    updateAddToDatabase(id: string, data: AddToDatabaseParams): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.patch(`/add-to-database/${id}`, data));
    }

    deleteAddToDatabase(id: string): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.delete(`/add-to-database/${id}`));
    }

    getFullHierarchy(): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get('/add-to-database/tree'));
    }

    getRootNodes(): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get('/add-to-database/roots'));
    }

    getChildren(parentId: string): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get(`/add-to-database/${parentId}/children`));
    }
}

export const addToDatabaseService = new AddToDatabaseService();
